import { useEffect, useState } from "react";
import { Breadcrumbs } from "../../../Home/Breadcrumb"
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEmpresaSupervisora } from "../../../../hooks/useEmpresaSupervisora";
import { EmpresaSupervisora } from "../../../../types/EmpresaSupervisora";
import { ToastContainer, toast } from "react-toastify";
import SeccionEmpresaSupervisora from "./EmpresaSupervisora";
import SeccionEmpresasGestoras from "./EmpresasGestoras";
import Confirm from "../../../../components/Confirm";


// Mismo criterio que Usuario y Contratista
export const EMAIL_REGEX = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

// Un mail ya guardado que no se modifica no se revalida, para no bloquear datos cargados antes de esta validacion
export const mailConFormatoInvalido = (email: string | undefined, emailOriginal: string | undefined) =>
    !!email?.trim() && email.trim() !== (emailOriginal || '').trim() && !EMAIL_REGEX.test(email.trim());

export type FormEmpresaSupervisoraErrors = {
    nombreEmpresa?: string;
    email?: string;
};

export const CrearEmpresaSupervisora = () => {
    const {
        handleEmpresaSupervisoraSelected, empresaSupervisoraInitial, empresaSupervisoraSelected, guardarEmpresaSupervisora, buscarEmpresaSupervisora,
    } = useEmpresaSupervisora();

    const [empresaSupervisoraForm, setEmpresaSupervisoraForm] = useState<EmpresaSupervisora>(empresaSupervisoraInitial);
    const [edit, setEdit] = useState<boolean>(false);
    const [view, setView] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const toggle = () => setShowModal(!showModal);

    const [formErrors, setFormErrors] = useState<FormEmpresaSupervisoraErrors>({
        nombreEmpresa: '',
        email: '',
    });

    const navigate = useNavigate();
    const { id } = useParams();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (id) {
            buscarEmpresaSupervisora(id);
            setEdit(true);
            const accionActual = searchParams.get("action");
            if (accionActual === 'view') {
                setView(true);
            }
        } else {
            handleEmpresaSupervisoraSelected(empresaSupervisoraInitial)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setEmpresaSupervisoraForm(empresaSupervisoraSelected)
    }, [empresaSupervisoraSelected])

    const handleGuardar = () => {
        let esValido = true;

        if (!empresaSupervisoraForm.nombreEmpresa?.trim()) {
            toast.error('Debe informar el campo [Nombre Empresa]');
            esValido = false;
        }
        if (!empresaSupervisoraForm.email?.trim()) {
            toast.error('Debe informar el campo [Mail]');
            esValido = false;
        } else if (mailConFormatoInvalido(empresaSupervisoraForm.email, empresaSupervisoraSelected.email)) {
            toast.error('El campo Mail no tiene un formato válido');
            esValido = false;
        }
        if (!empresaSupervisoraForm.empresasGestoras || empresaSupervisoraForm.empresasGestoras.length === 0) {
            toast.error('Debe asociar al menos una empresa gestora');
            esValido = false;
        }

        if (!esValido) {
            setFormErrors({
                nombreEmpresa: empresaSupervisoraForm.nombreEmpresa?.trim() ? '' : 'El campo Nombre Empresa es obligatorio',
                email: !empresaSupervisoraForm.email?.trim() ? 'El campo Mail es obligatorio'
                    : mailConFormatoInvalido(empresaSupervisoraForm.email, empresaSupervisoraSelected.email) ? 'El campo Mail no tiene un formato válido' : '',
            });
            return;
        }

        guardarEmpresaSupervisora({
            ...empresaSupervisoraForm,
            id: empresaSupervisoraForm.id || undefined,
        })
            .then(response => {
                if (response.data) {
                    toast.success("Se guardó la Empresa Supervisora correctamente")
                    navigate('/empresasSupervisoras');
                }
            })
            .catch(err => {
                if (err.response?.status === 403) {
                    toast.error('No tiene permisos para realizar esta acción');
                } else {
                    toast.error(err.response?.data?.message || 'Hubo un error al guardar la Empresa Supervisora')
                }
            })
    }

    const handleCancelar = (e: any) => {
        e.preventDefault();
        setShowModal(true)
    }
    const cancelar = () => {
        toggle();
        navigate('/empresasSupervisoras')
    }
    const handleVolver = () => {
        navigate('/empresasSupervisoras')
    }

    return (
        <>
            <ToastContainer />

            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                        <Breadcrumbs
                            title={edit ? (view ? 'Vista' : 'Editar') : 'Nuevo'}
                            titlePage={view ? 'Vista Empresas Supervisoras' : 'Empresas Supervisoras'}
                            nameFirst={'Configuración'}
                            urlFirst={'/'}
                            nameSecond={'Empresas Supervisoras'}
                            urlSecond={'/empresasSupervisoras'}
                        />
                        <Confirm isOpen={showModal} toggle={toggle} title='Cancelar' yesFn={cancelar}>
                            <div className="form-horizontal">
                                <div className="row">
                                    {<p>Confirma Salir sin guardar los cambios?</p>}
                                </div>
                            </div>
                        </Confirm>

                        <SeccionEmpresaSupervisora
                            empresaSupervisoraForm={empresaSupervisoraForm}
                            setFormErrors={setFormErrors}
                            setEmpresaSupervisoraForm={setEmpresaSupervisoraForm}
                            emailOriginal={empresaSupervisoraSelected.email}
                            errors={formErrors} edit={edit} view={view} />

                        <SeccionEmpresasGestoras
                            empresasGestoras={empresaSupervisoraForm.empresasGestoras || []}
                            setEmpresasGestoras={(empresasGestoras) => setEmpresaSupervisoraForm({ ...empresaSupervisoraForm, empresasGestoras })}
                            idEmpresaSupervisora={empresaSupervisoraForm.id}
                            edit={edit}
                            view={view}
                        />

                        <br />
                        <div className="text-center">
                            {!view &&
                                <>
                                    <button className="btn btn-secondary mx-2" onClick={handleCancelar}>Cancelar</button>
                                    <button className="btn btn-success mx-2" onClick={handleGuardar}>Guardar</button>
                                </>
                            }
                            {view &&
                                <button className="btn btn-secondary mx-2" onClick={handleVolver}>Volver</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
